import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Nav from './../../components/Navigation';
import Menu from './../../components/skytone/Menu';
import Footer from './../../components/skytone/Footer';
import SkyHome from "./Home"
import SkyAbout from "./About"
import SkyModule from "./Module"
import SkyFrame from "./Frame"
import SkyWifi from "./Wifi"
import SkySetting from "./Setting"
import SkyFaq from "./Faq"
import { replaceImagesWithInlineSVG } from './../../common/replaceImagesWithInlineSVG'

const App = ({ pages }) => {

    const { pageName = 'home'} = useParams(); // URL에서 pageName을 가져옴
    const [menuOpened, setMenuState] = useState(false);


    const location = useLocation();
    const navigate = useNavigate();

    const [navValue, setNavValue] = useState(pageName ? pageName.toLowerCase() : 'home'); 

    useEffect(() => {
        setTimeout(() => {
            replaceImagesWithInlineSVG('img.svg');
        }, 5);
    }, []); // 빈 deps → 최초 1회만 실행

    useEffect(() => {
        window.scrollTo(0, 0); // 스크롤을 최상단으로 이동
        setNavValue(pageName ? pageName.toLowerCase() : 'home');
        setMenuState(false);            
        replaceImagesWithInlineSVG('img.svg');
    }, [location,pageName]); // location이 변경될 때마다 실행

    
    const renderComponent = () => {

        switch (pageName.toLowerCase()) {
            case 'home':
                return <SkyHome />;
            case 'about':
                return <SkyAbout />;
            case 'module':
                return <SkyModule />;
            case 'frame':
                return <SkyFrame />;
            case 'wifi':
                return <SkyWifi />;
            case 'setting':
                return <SkySetting />;
            case 'faq':
                return <SkyFaq />;
            default:
                navigate('/404'); // 404 페이지로 리디렉션
                return null;
        }
    };


    const changeMenuState = () => {
        setMenuState(!menuOpened)
    }

    return (
        <div id="app" className={menuOpened ? 'nav-opened' : ''}>
            <Nav handleMenu={changeMenuState} page={navValue} />
            <Menu />
            {renderComponent()}
            <Footer page={pageName} />
        </div>
    );
};

export default App;